import { render, staticRenderFns } from "./userLeft.vue?vue&type=template&id=06493fe4&scoped=true&"
import script from "./userLeft.vue?vue&type=script&lang=js&"
export * from "./userLeft.vue?vue&type=script&lang=js&"
import style0 from "./userLeft.vue?vue&type=style&index=0&id=06493fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06493fe4",
  null
  
)

export default component.exports